import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMapEditFlat: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconMapEditFlat"><Path d="M7.75 6H12.5V7.5H7.75V16H5.25C4.2835 16 3.5 16.7835 3.5 17.75C3.5 18.7165 4.2835 19.5 5.25 19.5H19.5V12H21V21H5.25C3.45507 21 2 19.5449 2 17.75V6.25C2 4.45507 3.45507 3 5.25 3H7.75V6Z" fill="currentColor"/><Path d="M16.9697 5.63672C17.9069 4.69952 19.426 4.69958 20.3633 5.63672C21.3005 6.57394 21.3005 8.09305 20.3633 9.03027L16.3936 13H13V9.60645L16.9697 5.63672Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMapEditFlat;
